<template>
  <div class="activistyCostAttribution">
    <div class="common_group">
      <div class="title">
        <img src="@/assets/images/costIcon.png">
        <span>{{ $t('newApp.Attribute.aoe') }}</span>
        <div class="buttonBar">
          <el-button type="primary" v-if="echoData.showAdditionExpense && !echoData.marketActivity.reportType" @click="addCostBtn">
            {{ $t('home.AE') }}
          </el-button>
          <el-button plain v-if="echoData.allowPurchase" @click="directEPSApply">{{ $t('eventList.PR') }}</el-button>
          <el-button plain v-if="echoData.allowPurchase" @click="directEPSPage">{{ $t('eventList.VPR') }}</el-button>
        </div>
      </div>
      <!--      <div class="totalAmount">活动总金额：{{ totalCost }}</div>-->
      <commonTable ref="activistyCostAttribution" :is-choice-flag="true" :whether-check-method="whetherCheckMethod"
                   :footer-cost="{ label: $t('eventList.Taoa'), val: totalCost }"
      />
    </div>
    <div class="common_group" v-if="rescindedTableData.length > 0">
      <div class="title">
        <img src="@/assets/images/costIcon.png">
        <span>{{ $t('eventList.Aore') }}</span>
      </div>
      <commonTable ref="rescindedActivistyCostTable" />
    </div>
    <!-- 活动费用明细 -->
    <activityCostDialog :row-data="rowData" :activity-dialog-visible="activityDialogVisible"
                        @dialogCloseHandle="activityCloseHandle"
    />
    <!-- 广告品费用明细 -->
    <advertCostDialog :row-data="rowData" :advert-cost-dialog-visible="advertCostDialogVisible"
                      @dialogCloseHandle="advertCloseHandle"
    />
    <!-- 广告品费用新版明细 -->
    <advertCostNewDialog :row-data="currentRowData" :advert-cost-dialog-visible="advertCostNewDialogVisible"
                         @dialogCloseHandle="advertCloseHandle"
    />
    <!-- 审批流 -->
    <approvalProcessDialog
      :is-report="echoData.marketActivity && echoData.marketActivity.submitType === 'report_submit'" :row-data="rowData"
      :approval-process-visible="approvalProcessVisible" @dialogCloseHandle="approvalCloseHandle"
    />
    <loanDetailsDialog :row-data="rowData" :loan-details-visible="loanDetailsVisible"
                       @dialogCloseHandle="loanDetailsCloseHandle"
    />
    <loanDialog :row-data="rowData" :currency-code="currencyCode" :instance-com-code="instanceComCode"
                :loan-visible="loanVisible" @dialogSubmitHandle="loanSubmitHandle" @dialogCloseHandle="loanCloseHandle"
    />
    <!-- 渠道核销 -->
    <qdVerifyDialog :echo-data="echoData" :row-data="rowData" :qd-verify-visible="qdVerifyVisible"
                    @dialogCloseHandle="qdVerifyCloseHandle" @dialogSubmitHandle="qdVerifySubHandle"
    />
  </div>
</template>

<script>
import commonTable from 'components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import activityCostDialog from '../../component/activityDetails/activistyCostAttribution/activityCostDialog';
import advertCostDialog from '../../component/activityDetails/activistyCostAttribution/advertCostDialog';
import advertCostNewDialog from '../../component/activityDetails/activistyCostAttribution/advertCostNewDialog';
import approvalProcessDialog from '../../component/activityDetails/activistyCostAttribution/approvalProcessDialog';
import loanDetailsDialog from '../../component/activityDetails/activistyCostAttribution/loanDetailsDialog';
import loanDialog from '../../component/activityDetails/activistyCostAttribution/loanDialog';
import qdVerifyDialog from '../../component/activityDetails/activistyCostAttribution/qdVerifyDialog';
import { activistyCostAttribution, eps, activityQueryDetails } from '../../service';
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
import { ExecutionFeedbackServer } from '@/API/executionFeedback';
import { isNotEmpty } from '../../../../utils/utils';
// import { gotoCustomer } from '../../component/activityDetails/ExecutionFeedback';

export default {
  data () {
    return {
      tableData: [],
      rescindedTableData: [],
      totalCost: 0,
      rowData: {},
      currentRowData: [],
      activityDialogVisible: false,
      advertCostDialogVisible: false,
      advertCostNewDialogVisible: false,
      approvalProcessVisible: false,
      loanDetailsVisible: false,
      loanVisible: false,
      qdVerifyVisible: false,
      processArr: [],
      currencyCode: '',
      instanceComCode: '',
      lang: localStorage.getItem('lang') || 'zh-CN',
      remainAvailableAmountList: [], // 行业报备模板费用列表
      industryReportActivityCode: '' // 行业报备活动code
    };
  },
  props: {
    echoData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    commonTable,
    activityCostDialog,
    advertCostDialog,
    advertCostNewDialog,
    approvalProcessDialog,
    loanDetailsDialog,
    loanDialog,
    qdVerifyDialog
  },
  watch: {
    echoData: {
      deep: true,
      handler (newVal) {
        this.tableData = [];
        if (newVal.marketActivity.industryReportActivityCode) {
          this.industryReportActivityCode = newVal.marketActivity.industryReportActivityCode;
          this.getQueryRemainAvailableAmount();
        }
        this.echoData.mactExpenseBelongVOList.forEach(item => {
          let data = {
            ...item.mactExpenseBelong,
            allsmartOrderVOList: item.allsmartOrderVOList,
            advertiseExpenseDetails: item.advertiseExpenseDetails,
            activityExpenseDetails: item.activityExpenseDetails,
            salerName: item.mactExpenseBelong.salerName,
            applyUserName: item.mactExpenseBelong.applyUserName,
            taskId: item.mactFlowTask ? item.mactFlowTask.taskId : null,
            allowBorrow: item.allowBorrow,
            allowCancel: item.allowCancel,
            allowVerification: item.allowVerification,
            borrowingMoneyTotal: item.borrowingMoneyTotal,
            status: item.status,
            budget: item.budget,
            realBudget: item.realBudget,
            isLocalWriteOff: item.isLocalWriteOff
          };
          if (item.status === this.$t('general.undone')) {
            this.rescindedTableData.push(data);
          } else {
            this.tableData.push(data);
          }
        });
        this.currencyCode = this.echoData.marketActivity.currencyCode;
        this.instanceComCode = this.echoData.marketActivity.financialSystemCode;
        this.totalCost = this.echoData.marketActivity.totalCost;
        this.loadActivistyCostTable();
        this.loadRescindedActivistyCostTable();
      },
      immediate: true
    }
  },
  methods: {
    getRowTemplateCost (row) {
      if (this.remainAvailableAmountList.length < 0 || row.expenseTypeCode !== 'EI201') {
        return null;
      };
      const data = this.remainAvailableAmountList.find(item => row.deptCode === item.deptCode && row.expenseTypeCode === item.expenseTypeCode);
      return isNotEmpty(data) ? data : null;
    },
    isTemplateCost () {
      // 费用归属列表中是否有行业报备模板费用
      if (this.$refs.activistyCostAttribution.tableData && this.remainAvailableAmountList.length <= 0) {
        return false;
      }
      const { dataList } = this.$refs.activistyCostAttribution.tableData;
      return dataList.some(row =>
        this.remainAvailableAmountList.some(item =>
          row.expenseTypeCode === item.expenseTypeCode && row.deptCode === item.deptCode
        )
      );
    },

    // 获取行业报备模板费用
    getQueryRemainAvailableAmount () {
      const activityCode = this.industryReportActivityCode;
      newApplicationFormApi.queryRemainAvailableAmount(activityCode).then(res => {
        if (res.status === '200') {
          if (isNotEmpty(res.data)) {
            this.remainAvailableAmountList = res.data;
            this.loadActivistyCostTable();
          }
        }
      });
    },
    qdVerifySubHandle (data) {
      let requestFun = data.qdWriteOff.writeOffCode
        ? activistyCostAttribution.qdVerifyEditSubmit(data)
        : activistyCostAttribution.qdVerifySubmit(data);
      this.$store.commit('setSubPageLoading', true);
      requestFun.then(res => {
        this.$store.commit('setSubPageLoading', false);
        if (res.status === '200') {
          this.$message.success(this.$t('general.SubSucc'));
          this.qdVerifyVisible = false;
          this.$router.push({
            path: '/activityDetails',
            query: {
              activityCode: this.$route.query.activityCode,
              activeName: 'activityBasicInformation',
              refreshFlag: this.$route.query.refreshFlag
                ? Number(this.$route.query.refreshFlag) + 1
                : 1
            }
          });
        }
      });
    },
    qdVerifyHandle (row) {
      this.rowData = row;
      this.qdVerifyVisible = true;
    },
    qdVerifyCloseHandle () {
      this.qdVerifyVisible = false;
    },
    whetherCheckMethod ({ row }) {
      return !!row.taskId;
    },
    getCheckedItem () {
      return this.$refs.activistyCostAttribution.getCheckboxRecords();
    },
    addCostBtn () {
      // 需要带入参数
      this.$router.push({
        path: '/addCostDetails',
        query: {
          activityCode: this.echoData.marketActivity.activityCode,
          unionChannelName: this.echoData.marketActivity.unionChannelName,
          activityClassificationCode: this.echoData.marketActivity
            .activityClassificationCode,
          callback: this.$route.path
        }
      });
      // sessionStorage.setItem('echoData', JSON.stringify(this.echoData));
    },
    // 采购申请
    directEPSApply () {
      eps
        .directEPSApply(this.echoData.marketActivity.activityCode)
        .then(res => {
          if (res.status === '200') {
            window.open(res.data);
          } else {
            this.$message.warning(res.err);
          }
        });
    },
    // 跳转采购页面
    directEPSPage () {
      eps.directEPSPage().then(res => {
        if (res.status === '200') {
          window.open(res.data);
        } else {
          this.$message.warning(res.err);
        }
      });
    },
    activityCostBtn (row) {
      this.rowData = row;
      this.activityDialogVisible = true;
    },
    activityCloseHandle () {
      this.activityDialogVisible = false;
    },
    advertCloseHandle () {
      this.advertCostDialogVisible = false;
      this.advertCostNewDialogVisible = false;
    },
    advertCostBtn (row) {
      if (isNotEmpty(row.allsmartOrderVOList)) {
        this.currentRowData = row.allsmartOrderVOList;
        this.advertCostNewDialogVisible = true;
      } else if (isNotEmpty(row.advertiseExpenseDetails)) {
        this.rowData = row;
        this.advertCostDialogVisible = true;
      } else {
        this.$message.error(this.$t('eventList.Acie'));
      }
    },
    approvalCloseHandle () {
      this.approvalProcessVisible = false;
    },
    approvalProcessBtn (row, column) {
      console.log(row, column);
      this.rowData = row;
      this.approvalProcessVisible = true;
    },
    loanDetailsBtn (row) {
      this.rowData = row;
      this.loanDetailsVisible = true;
    },
    loanDetailsCloseHandle () {
      this.loanDetailsVisible = false;
    },
    loanBtn (row) {
      // 借款
      this.rowData = row;
      this.loanVisible = true;
    },
    loanSubmitHandle (rowNew) {
      this.loanVisible = false;
      this.$refs.activistyCostAttribution.reviseRow(rowNew, '', '');
      this.loadActivistyCostTable();
    },
    loanCloseHandle () {
      this.loanVisible = false;
    },
    // 核销
    async rjVerifyHandle (row) {
      // 快捷申请没有客商录入
      if (this.echoData.marketActivity.submitType !== 'quick_submit') {
        // 查询是否有客商录入
        const res = await ExecutionFeedbackServer.customerExist(
          this.$route.query.activityCode
        );
        if (!res.data) {
          this.gotoCustomer();
          return;
        }
      }
      // 校验活动信息和费用信息是否合法
      await activistyCostAttribution.startWriteOff(row.id).then(res => {
        if (res.status === '200') {
          // 跳转费用系统
          const lang = this.lang === 'zh-CN' ? 'zh' : 'en';
          const { sysUser } = this.$store.state.userInfo;
          const userId = sysUser.userId;
          const url = window._env_.VUE_APP_COST_SYSTEM_URL + row.id + `&lang=${lang}&uid=${userId}`;
          // let url = '';
          // if (this.lang === 'zh-CN') {
          //   url = window._env_.VUE_APP_EXPENSESYSTEM_URL + row.id;
          // } else {
          //   url = window._env_.VUE_APP_EXPENSESYSTEM_EN_URL + row.id;
          // }
          window.open(url);
        }
      });
    },
    writeOffBtn (row) {
      // 是否可以特例核销 0：否 1：是 默认是 新的一年要把去年的数据刷为否
      activityQueryDetails.writeOffCheck({ activityCode: this.$route.query.activityCode }).then(res => {
        if (res.status === '200') {
          const result = JSON.parse(JSON.stringify(res.data));
          if (result) {
            if (row.isLocalWriteOff === 1) {
              this.$confirm(this.$t('notic.witeOffInfo'), this.$t('general.Hint'), {
                confirmButtonText: this.$t('btn.OK'),
                cancelButtonText: this.$t('btn.Cancel'),
                type: 'warning'
              }).then(() => {
                const params = {
                  expenseBelongId: row.id
                };
                activityQueryDetails.specialWriteOffSubmit(params).then(res => {
                  if (res.status === '200') {
                    this.$message.success(this.$t('general.OperSucc'));
                    this.$emit('refresh');
                  }
                });
              }).catch(() => { });
              return false;
            }
            if (row.ifSpecialWriteOff === 1) {
              // 当前申请人类型为qd
              if (this.echoData.marketActivity.applyUserType === 'qd') {
                this.qdVerifyHandle(row);
                // // 当前对应销售 === 当前申请人
                //   if (row.salerName === this.echoData.marketActivity.applyUserName) {
                //     this.qdVerifyHandle(row);
                //   } else {
                //     this.rjVerifyHandle(row);
                //   }
              } else {
                this.rjVerifyHandle(row);
              }
            } else {
              this.$alert(this.$t('newApp.Attribute.WriteOffInfo'), this.$t('general.Hint'), {
                confirmButtonText: this.$t('btn.OK')
              });
            }
          } else {
            this.$alert(this.$t('newApp.Attribute.WriteOffCheck'), this.$t('general.Hint'), {
              confirmButtonText: this.$t('btn.OK')
            });
          }
        }
      });
    },
    // 提示，跳转录入客商
    gotoCustomer () {
      this.$confirm(this.$t('eventList.Iehnyetp'), this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      })
        .then(() => {
          this.$emit('jumpTabsHandle');
        })
        .catch(() => { });
    },
    isShowProductLine (data) {
      return data.some(item => {
        return item.productLine;
      });
    },
    isShowVerify (data) {
      return data.some(item => {
        return item.allowVerification;
      });
    },
    revokeBtn (row) {
      console.log(row);
      const info = this.echoData.marketActivity.reportType ? this.$t('eventList.qdcxgfymhd') : this.$t('eventList.Aysywtctf');
      this.$confirm(info, this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      })
        .then(() => {
          let requestUrl = activistyCostAttribution.activistyCostRevoke;
          // 判断是否是报备：如果是则调用报备撤销费用接口
          if (this.echoData.marketActivity.submitType === 'report_submit') {
            requestUrl = activistyCostAttribution.reportRevoke;
          }
          this.$store.commit('setSubPageLoading', true);
          requestUrl(row.id).then(res => {
            this.$store.commit('setSubPageLoading', false);
            if (res.status === '200') {
              this.$router.push({
                path: '/activityDetails',
                query: {
                  metaActive: this.$route.query.metaActive,
                  activityCode: this.$route.query.activityCode,
                  activeName: 'activityBasicInformation',
                  refreshFlag: this.$route.query.refreshFlag
                    ? Number(this.$route.query.refreshFlag) + 1
                    : 1
                }
              });
              this.$message.success(this.$t('general.OperSucc'));
            } else if (res.status === '800150') {
              const { expCode, activityCode } = row;
              const { sysUser } = this.$store.state.userInfo;
              const eventcode = activityCode;
              const expensecode = expCode;
              const rjPercode = sysUser.userId;
              const params = {
                method: 'order_cancelpage',
                reqData: `<?xml version="1.0" encoding="utf-8"?><body><eventcode>${eventcode}</eventcode><expensecode>${expensecode}</expensecode><rj_percode>${rjPercode}</rj_percode><lang>${this.lang === 'zh-CN' ? 'zh_cn' : 'en_us'}</lang></body>`,
                lang: this.lang === 'zh-CN' ? 'zh_cn' : 'en_us'
              };
              this.$confirm(this.$t('newApp.Attribute.RevokeInfo'), this.$t('general.Hint'), {
                confirmButtonText: this.$t('approvalCenter.ToDealWith'),
                cancelButtonText: this.$t('btn.Cancel'),
                type: ''
              }).then(() => {
                newApplicationFormApi.getGiftUrl(params).then(res => {
                  if (res.status === '200') {
                    window.open(res.data);
                  }
                });
              }).catch(() => {

              });
            }
          });
        })
        .catch(() => { });
    },
    verifyDetailBtn (row) {
      // 如果是渠道核销单就弹出核销详情弹框，否则跳转至费用系统
      if (this.echoData.marketActivity.applyUserType === 'qd') {
        this.qdVerifyHandle(row);
      } else {
        let url = '';
        if (this.lang === 'zh-CN') {
          url = window._env_.VUE_APP_EXPENSESYSTEM_URL + row.id;
        } else {
          url = window._env_.VUE_APP_EXPENSESYSTEM_EN_URL + row.id;
        }
        window.open(url);
      }
    },
    loadActivistyCostTable () {
      let metaActive = this.$route.query.metaActive;
      let tableRow = new TableRow();
      tableRow.push(new TableColumns()._width('50')._others('checkbox'));
      // 申请人
      tableRow.push(
        new TableColumns()
          ._width('120')
          ._title(this.$t('approvalCenter.TheApplicant'))
          ._data('applyUserName')
      );
      // 财务体系
      tableRow.push(
        new TableColumns()
          ._width('100')
          ._title(this.$t('newApp.BasicInfo.fs'))
          ._data('financialSystemName')
      );
      // 客户类型
      tableRow.push(
        new TableColumns()
          ._width('100')
          ._title(this.$t('newApp.BasicInfo.toc'))
          ._data('currencyType')
      );
      // 费用归属
      tableRow.push(
        new TableColumns()
          ._width('170')
          ._title(this.$t('approvalCenter.AttributionExpenses'))
          ._data('deptName')
      );
      // 费用类型
      tableRow.push(
        new TableColumns()
          ._width('130')
          ._title(this.$t('approvalCenter.TypeFee'))
          ._data('expenseType')
      );
      // 细分市场
      tableRow.push(
        new TableColumns()
          ._width('160')
          ._title(this.$t('approvalCenter.MarketSegmentation'))
          ._data('subMarket')
      );
      // 产品线
      if (this.isShowProductLine(this.tableData)) {
        tableRow.push(
          new TableColumns()
            ._width('120')
            ._title(this.$t('newApp.Attribute.pl'))
            ._data('productLine')
        );
      }
      // 单场费用上限
      if (this.remainAvailableAmountList.length > 0 && this.isTemplateCost()) {
        tableRow.push(
          new TableColumns()
            ._title('industryReport.hybblb.list.dcfysx')
            ._data('singleActivityExpenseLimit')
            ._align('right')
            ._width('9%')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                const singleActivityExpenseLimit = row.expenseTypeCode === 'EI201' && this.getRowTemplateCost(row) && this.getRowTemplateCost(row).singleActivityExpenseLimit;
                return (
                  <el-popover
                  placement="bottom"
                  title=""
                  width="250"
                  disabled={!singleActivityExpenseLimit}
                  trigger="hover"
                  content={singleActivityExpenseLimit}>
                  <div class="popover-info" slot="reference">
                      {(singleActivityExpenseLimit || '-')}
                  </div>
                </el-popover>
                );
              }
            })
        );
      }
       // 报备类型显示报备金额
      if (this.echoData && this.echoData.marketActivity && this.echoData.marketActivity.reportType) {
        tableRow.push(
          new TableColumns()
            ._title(this.$t('newApp.Attribute.bbje'))
            ._data('reportApplyAmount')
            ._width('8%')
            ._align('right')
        );
      }

      tableRow.push(
        new TableColumns()
          ._width('160')
          ._title(this.$t('approvalCenter.AmountApplication'))
          ._align('right')
          ._data('applyAmount')
      );
      tableRow.push(
        new TableColumns()
          ._width('130')
          ._title(this.$t('approvalCenter.CostActivities'))
          ._data('activityCost')
          ._align('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <el-button
                  type="text"
                  disabled={!row[column.property]}
                  onClick={() => {
                    this.activityCostBtn(row);
                  }}
                >
                  {row[column.property] ? row[column.property] : '-'}
                </el-button>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('180')
          ._title(this.$t('approvalCenter.CostAdvertisingDoods'))
          ._data('advertisingCost')
          ._align('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <el-button
                  type="text"
                  disabled={!row[column.property]}
                  onClick={() => {
                    this.advertCostBtn(row);
                  }}
                >
                  {row[column.property] || '-'}
                </el-button>
              );
            }
          })
      );
      if (metaActive !== '/home' && metaActive !== '/pendingApproval') {
        tableRow.push(
          new TableColumns()
            ._title(this.$t('btn.Borrowing'))
            ._width('120')
            ._data('borrowingMoneyTotal')
            ._align('right')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                return (
                  <div>
                    <el-button
                      type="text"
                      disabled={!row[column.property]}
                      onClick={() => {
                        this.loanDetailsBtn(row);
                      }}
                    >
                      {row[column.property] ? row[column.property] : '-'}
                    </el-button>
                  </div>
                );
              }
            })
        );
      }
      if (this.$store.state.userInfo.userType === 'rj') {
        tableRow.push(
          new TableColumns()
            ._width('120')
            ._title(this.$t('approvalCenter.TotalBudget'))
            ._align('right')
            ._data('budget')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                return (
                  <div>
                    <span>
                      {row.budget}
                    </span>
                  </div>
                );
              }
            })
        );
        tableRow.push(
          new TableColumns()
            ._width('200')
            ._title(this.$t('approvalCenter.BalanceBudget'))
            ._align('right')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                return (
                  <div>
                    <span>
                      {!row.realBudget ? 0.0 : row.realBudget.toFixed(2)}
                    </span>
                  </div>
                );
              }
            })
        );
      }
      tableRow.push(
        new TableColumns()
          ._width('200')
          ._title(this.$t('general.Remarks'))
          ._data('note')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <el-popover
                  placement="bottom"
                  title=""
                  disabled={!row.note}
                  width="300"
                  trigger="hover"
                  content={row.note}>
                  <div class="popover-info" slot="reference">
                    {row.note}
                  </div>
                </el-popover>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Status'))
          ._width('150')
          ._fixed('right')
          ._data('status')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button
                    type="text"
                    onClick={() => {
                      this.approvalProcessBtn(row, column);
                    }}
                  >
                    {row[column.property]}
                  </el-button>
                </div>
              );
            }
          })
      );
      // if ((metaActive !== '/home' && metaActive !== '/pendingApproval') || (metaActive === '/home' && this.isShowVerify(this.tableData))) {
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._width('200')
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              // writeOffDom = (
              //   <el-tooltip content="渠道核销功能还在紧急开发中，具体上线时间请以系统通知为准。" placement="bottom">
              //     <el-button type="text" class="forbid" onClick={() => { }}>核销</el-button>
              //   </el-tooltip>
              // );
              // 状态（ -1-删除  0-草稿  10-审批中 20-驳回  30-待反馈  40-待核销  50-核销中 55-核销驳回（渠道） 60-核销结束  70-召回  80-撤销 ）
              return (
                // <div>
                //   {row.allowBorrow ? (
                //     <el-button
                //       type="text"
                //       onClick={() => {
                //         this.loanBtn(row);
                //       }}
                //     >
                //       {this.$t('btn.Borrowing')}
                //     </el-button>
                //   ) : <el-popover
                //           placement="top-start"
                //           width="200"
                //           trigger="hover"
                //           content={this.$t('newApp.Attribute.Borrowing')}>
                //           <span class="disabled-text" slot="reference">{ this.$t('btn.Borrowing') }</span>
                //         </el-popover>}
                //   {row.allowVerification ? (
                //     <el-button
                //       type="text"
                //       onClick={() => {
                //         this.writeOffBtn(row);
                //       }}
                //     >
                //       {this.$t('btn.WriteOff')}
                //     </el-button>
                //   ) : <el-popover
                //           placement="top-start"
                //           width="200"
                //           trigger="hover"
                //           content={this.$t('newApp.Attribute.WriteOff')}>
                //           <span class="disabled-text" slot="reference">{ this.$t('btn.WriteOff') }</span>
                //         </el-popover>}
                //   {row.allowCancel ? (
                //     <el-button
                //       type="text"
                //       onClick={() => {
                //         this.revokeBtn(row);
                //       }}
                //     >
                //       {this.$t('btn.Revoke')}
                //     </el-button>
                //   ) : <el-popover
                //           placement="top-start"
                //           width="200"
                //           trigger="hover"
                //           content={this.$t('newApp.Attribute.Revoke')}>
                //           <span class="disabled-text" slot="reference">{ this.$t('btn.Revoke') }</span>
                //         </el-popover>}
                //   {row.stat === 50 || row.stat === 60 ? (
                //     <el-button
                //       type="text"
                //       onClick={() => {
                //         this.verifyDetailBtn(row);
                //       }}
                //     >
                //       {this.$t('btn.Doc')}
                //     </el-button>
                //   ) : null}
                // </div>
                <div>
                  {
                    !row.allowBorrow && !row.allowVerification && !row.allowCancel && !(row.stat === 50 || row.stat === 60)
                      ? <div style="marginLeft:10px">-</div>
                      : <div>
                        {
                          row.allowBorrow ? (
                            <el-button type="text" onClick={() => { this.loanBtn(row); }}>{this.$t('btn.Borrowing')}</el-button>
                          ) : this.echoData.marketActivity.applyUserType !== 'qd' && (row.stat === 30 || row.stat === 40 || row.stat === 50 || row.stat === 55) ? <el-popover
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            content={this.$t('newApp.Attribute.Borrowing')}>
                            <span class="disabled-text" slot="reference">{this.$t('btn.Borrowing')}</span>
                          </el-popover> : null
                        }
                        {
                          row.allowVerification && row.applyAmount !== 0 ? (
                            <el-button type="text" onClick={() => { this.writeOffBtn(row); }}>{this.$t('btn.WriteOff')}</el-button>
                          ) : row.allowVerification && row.applyAmount === 0 ? (
                            <span class="disabled-text" style="marginLeft:5px">{this.$t('btn.WriteOff')}</span>
                          ) : null
                        }
                        {
                          row.allowCancel ? (
                            <el-button type="text" onClick={() => { this.revokeBtn(row); }}>{this.$t('btn.Revoke')}</el-button>
                          ) : null
                        }
                        {
                          row.stat === 50 || row.stat === 60 ? (
                            <el-button type="text" onClick={() => { this.verifyDetailBtn(row); }}>{this.$t('btn.Doc')}</el-button>
                          ) : null
                        }
                      </div>
                  }
                </div>
              );
            }
          })
      );
      // }
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.activistyCostAttribution.setColumn(column, {
          page: false
        });
        this.$refs.activistyCostAttribution.loadStaticTable(this.tableData);
        this.$refs.activistyCostAttribution.setCheckboxRow(this.tableData);
      });
    },
    loadRescindedActivistyCostTable () {
      if (this.rescindedTableData.length <= 0) {
        return;
      }
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._width('100')
          ._title(this.$t('newApp.BasicInfo.Applicant'))
          ._data('salerName')
      );
      tableRow.push(
        new TableColumns()
          ._width('130')
          ._title(this.$t('newApp.Attribute.cad'))
          ._data('deptName')
      );
      tableRow.push(
        new TableColumns()
          ._width('130')
          ._title(this.$t('newApp.Attribute.toe'))
          ._data('expenseType')
      );
      tableRow.push(
        new TableColumns()
          ._width('100')
          ._title(this.$t('newApp.Attribute.ms'))
          ._data('subMarket')
      );
      if (this.isShowProductLine(this.rescindedTableData)) {
        tableRow.push(
          new TableColumns()
            ._width('100')
            ._title(this.$t('newApp.Attribute.pl'))
            ._data('productLine')
        );
      }
      tableRow.push(
        new TableColumns()
          ._width('150')
          ._title(this.$t('eventList.FeeAA'))
          ._data('applyAmount')
      );
      tableRow.push(
        new TableColumns()
          ._width('120')
          ._title(this.$t('newApp.Attribute.ac'))
          ._data('activityCost')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <el-button
                  type="text"
                  disabled={!row[column.property]}
                  onClick={() => {
                    this.activityCostBtn(row);
                  }}
                >
                  {row[column.property] ? row[column.property] : '-'}
                </el-button>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('120')
          ._title(this.$t('newApp.Attribute.coam'))
          ._data('advertisingCost')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <el-button
                  type="text"
                  disabled={!row[column.property]}
                  onClick={() => {
                    this.advertCostBtn(row);
                  }}
                >
                  {row[column.property] || ''}
                </el-button>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('110')
          ._title(this.$t('general.Remarks'))
          ._data('note')
          // expenseDetailNote
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Status'))
          ._width('120')
          ._data('status')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button
                    type="text"
                    onClick={() => {
                      this.approvalProcessBtn(row);
                    }}
                  >
                    {row[column.property]}
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.rescindedActivistyCostTable.setColumn(column, {
          page: false
        });
        this.$refs.rescindedActivistyCostTable.loadStaticTable(
          this.rescindedTableData
        );
      });
    }
  },
  mounted () {

  }
};
</script>

<style lang="scss" scoped>
.activistyCostAttribution {
  >div {
    .forbid {
      cursor: not-allowed;
      color: #c0c4cc !important;
    }
  }

  .totalAmount {
    padding: 8px 0 16px;
    font-weight: bold;
    font-size: 14px;
    color: #3384fe;
  }

  .btnBar {
    margin: 20px 0;
  }

  .disabled-text {
    margin-right: 7px;
    color: #c0c4cc;
    cursor: default;
  }

  .popover-info {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
